// Shared API request/response types. Grows as endpoints are built.
export const MODULE_KEYS = ['payroll', 'evaluations', 'contrats', 'documents', 'espace', 'recrutement'];
export const DEFAULT_MODULES = {
    payroll: true, evaluations: true, contrats: true, documents: true, espace: true, recrutement: true,
};
export const DEFAULT_ESPACE_OPTIONS = {
    attestation: true, recupClaims: true, docRequests: true, leaveRequests: true,
};
//# sourceMappingURL=types.js.map